import { Bogle_Medium, Bogle_Regular } from 'constants/constant';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';

const { PURPLE, BLACK, LIGHT_GREY, TOGGLE_ACTIVE } = colors;

const rippledLabelRadioButtonStyles = makeStyles(() => ({
	buttonRadio: {
		justifyContent: 'center',
		width: '100%',
		padding: 6,
		borderRadius: 0,
		fontSize: '0.875rem',
		lineHeight: 1.75,
		fontWeight: 500,
		marginRight: 'unset',
		marginLeft: 'unset',
		PrivateSwitchBase: {
			input: {
				opacity: 0
			}
		}
	},
	formControlLabel: {
		width: '50%',
		marginLeft: 0,
		marginRight: 0
	},
	buttonActive: {
		background: TOGGLE_ACTIVE,
		border: `1px solid ${PURPLE} !important`,
		fontFamily: `${Bogle_Medium} !important`,
		fontWeight: 500,
		color: `${PURPLE}!important`
	},
	buttonInactive: {
		fontFamily: Bogle_Regular,
		border: `1px solid ${LIGHT_GREY}`,
		color: `${BLACK} !important`
	},
	customTooltipStyle: {
		width: 200,
		backgroundColor: '#6D6E71!important',
		fontSize: '14px!important',
		fontFamily: Bogle_Medium
	}
}));

export default rippledLabelRadioButtonStyles;
